export default "assets/images/icons/entity-surface-c36d7977.svg";